/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { createIntl, createIntlCache } from '@formatjs/intl'
import { Grid, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import { StepsPathRank } from './StepsPathList'

const cache = createIntlCache()
const intl = createIntl(
  {
    locale: 'en-US',
    messages: {},
  },
  cache,
)

interface Props {
  rank: StepsPathRank
  isEven: boolean
  isActive: boolean
  measurement: 'km' | 'miles'
}
function RoadTile(props: Props) {
  const { rank, isEven, isActive, measurement } = props
  const { name, value, renderIcon } = rank

  const valueFormatted = useMemo(() => {
    const valueKm = value / 1000

    let distance = valueKm
    let distanceLabel = 'km'

    if (measurement === 'miles') {
      distance *= 0.621371

      const floatingLength = distance > 100 ? 0 : 2
      distance = Number(distance.toFixed(floatingLength))
      distanceLabel = 'miles'
    }

    const str = intl.formatNumber(distance)

    return `${str} ${distanceLabel}`
  }, [value, measurement])

  return (
    <div
      css={css`
        position: absolute;
        z-index: 5;
        top: 50%;
        left: -5px;
        right: 30px;
        transform: translateY(-50%);
        padding-top: 5px;
      `}
    >
      <Grid container direction={isEven ? 'row' : 'row-reverse'}>
        <div
          css={css`
            margin-left: 5px;
            margin-right: 5px;
          `}
        >
          {renderIcon({ isActive })}
        </div>
        <Grid item>
          <Grid container alignItems={'center'}>
            <Typography
              css={css`
                font-size: 13px;
                margin-right: 3px;
                font-weight: bold;
                line-height: 20px;
              `}
            >
              {name}
            </Typography>
            <Typography
              css={css`
                font-size: 13px;
              `}
            >
              {valueFormatted}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

export default RoadTile
